import React, { useEffect, useRef, useState } from "react"
import { Link } from "gatsby"
import { Spin as Hamburger } from "hamburger-react"
import { StaticImage } from "gatsby-plugin-image"
import { Helmet } from "react-helmet"
import useScrollPosition from "../../utilities/use-scroll-position"
import NavItems from "./nav-items"
import AdjustLink from "../adjust-link"
import useQueryParams from "query-params-hook"

const MenuMobile = ({ shouldShowBanner = false, light_version = false, lpV2 = false }) => {
  const { page_version } = useQueryParams()
  const { scrollY } = useScrollPosition()
  const [isScrolled, setIsScrolled] = useState(false)
  const [showNav, setShowNav] = useState(false)
  const [menuPosition, setMenuPosition] = useState(0)

  const [openMobileMenu, setOpenMobileMenu] = useState<any>(null)

  const topMobileMenuRef = useRef(null)

  useEffect(() => {
    setIsScrolled(scrollY >= 80)
  }, [scrollY])

  const toggleNav = (show: boolean) => {
    // @ts-ignore
    const navRect = topMobileMenuRef.current.getBoundingClientRect()
    const topMobileMenuHeight = navRect.top + navRect.height
    setMenuPosition(topMobileMenuHeight)
    setShowNav(show)
  }

  const handleOpenMenuClick = (menuItem: string) => {
    setOpenMobileMenu((current) => (current === menuItem ? null : menuItem))
  }

  return (
    <>
      <Helmet bodyAttributes={{ class: showNav ? "overflow-hidden" : "" }} />
      <div
        className={`inner-container fixed-top w-full mb-[-95px] block xl:hidden mobile-menu${
          isScrolled || showNav ? " background-menu" : ""
        } ${shouldShowBanner ? "show-banner" : ""}`}
      >
        {showNav && (
          <nav
            className="mobile-nav left-0 py-2 px-12"
            style={{
              top: `${menuPosition}px`,
              height: `calc(100vh - ${menuPosition}px)`,
            }}
          >
            <NavItems
              openMobileMenu={openMobileMenu}
              onOpenMenuClick={handleOpenMenuClick}
            />
            <div className="m-auto">
              <AdjustLink topMenu={true}>
                <StaticImage
                  src="../../images/cta.png"
                  alt="Download Now"
                  width={290}
                />
              </AdjustLink>
            </div>
          </nav>
        )}
        <div
          className="flex justify-between items-center"
          ref={topMobileMenuRef}
        >
          <div className="log-nav flex flex-1">
            {!light_version ? (
              <div className="p-5 pr-0 flex justify-center items-center space-x-1">
                <Link to={"/"}>
                  <StaticImage
                    src="../../images/logo.png"
                    alt="Free Slots - Jackpot Party Casino"
                    width={140}
                  />
                </Link>
                <div className="blog-link">
                  <Link
                    to="/blog/"
                    className="text-[#bb00b3] text-[15px] font-bold"
                  >
                    BLOG
                  </Link>
                </div>
              </div>
            ) : (
              <div className={"logo-wrapper p-5 flex justify-center items-center space-x-1"}>
                {lpV2 ? 
                  <StaticImage
                    src="../../images/lp-logo.png"
                    alt="Free Slots - Jackpot Party Casino"
                  />
                  :
                  <StaticImage
                    src="../../images/logo.png"
                    alt="Free Slots - Jackpot Party Casino"
                    width={140}
                  />
                }
                <div className="blog-link text-[#bb00b3] text-[15px] font-bold">
                  BLOG
                </div>
              </div>
            )}
          </div>
          <AdjustLink
            className={`hidden invisible min-w-[135px] ${!showNav && !page_version && isScrolled ? "!visible" : ""}`}
            topMenu={true}
            menuUrl={"https://app.adjust.com/1075oyjq_105yfcae_1083bqml"}
          >
            {isScrolled &&
              <StaticImage
                className="mr-6"
                src="../../images/cta.png"
                alt="Play Now"
                width={120}
              />
            }
          </AdjustLink>
        
          {!light_version && (
            <div className="flex space-x-3 pr-5 links-hamburger">
              <div>
                <Hamburger
                  label="hamburger-menu"
                  size={30}
                  color="white"
                  onToggle={(show) => toggleNav(show)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MenuMobile
